import React from 'react';
import PropTypes from 'prop-types';
import { Box, FormLabel, Paper, Switch, Typography } from '@esgian/esgianui';
import { getTransparentBackground } from '@helpers';
import { useSelector } from 'react-redux';
import { getThemeMode } from '@store/features';
import DashboardActivityMapDrawerHeader from '../DashboardActivityMap/Common/DashboardActivityMapDrawerHeader';

const VesselsMapSettings = ({
  onClose,
  showVesselsName,
  onChangeShowVesselsName,
  showPorts,
  onTogglePorts
}) => {
  const themeMode = useSelector(getThemeMode);

  const settingsSections = [
    {
      sectionTitle: 'Vessels',
      settings: [
        {
          label: 'Show vessel names',
          name: 'showVesselNames',
          value: showVesselsName,
          onChange: (e) => onChangeShowVesselsName(e.target.checked)
        }
      ]
    },
    {
      sectionTitle: 'Ports',
      settings: [
        {
          label: 'Show ports',
          name: 'showPorts',
          value: showPorts,
          onChange: (e) => onTogglePorts(e.target.checked)
        }
      ]
    }
  ];

  return (
    <Box height="100%" width={'20rem'}>
      <Paper
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          p: 2,
          backgroundColor: getTransparentBackground(themeMode),
          color: themeMode ? 'white' : 'black'
        }}>
        <DashboardActivityMapDrawerHeader title="Map Settings" onClose={onClose} />

        {settingsSections.map((section) => (
          <Box key={section.sectionTitle}>
            <Typography color={themeMode ? 'white' : 'black'}>{section.sectionTitle}:</Typography>
            <ul style={{ margin: 0, paddingLeft: '16px' }}>
              {section.settings.map((setting) => (
                <li key={setting.name}>
                  <Box display="flex" alignItems="center" justifyContent="space-between">
                    <FormLabel sx={{ color: themeMode ? 'white' : 'black' }}>
                      {setting.label}
                    </FormLabel>
                    <Switch
                      checked={setting.value}
                      onChange={setting.onChange}
                      disabled={setting.disabled}
                    />
                  </Box>
                </li>
              ))}
            </ul>
          </Box>
        ))}
      </Paper>
    </Box>
  );
};

VesselsMapSettings.propTypes = {
  onClose: PropTypes.func.isRequired,
  showVesselsName: PropTypes.bool.isRequired,
  onChangeShowVesselsName: PropTypes.func.isRequired,
  showPorts: PropTypes.bool.isRequired,
  onTogglePorts: PropTypes.func.isRequired
};

export default VesselsMapSettings;
